import * as t from 'io-ts'
import {OrErrorMessage} from './error'
import {OrganizationC} from '../Organization'
import {withId} from './id'

export const OrganizationsPageListResponseC = t.strict({
  data: t.readonlyArray(withId(OrganizationC)),
  total: t.number,
  page: t.number,
  pageSize: t.number,
  totalPages: t.number,
})
export type OrganizationsPageListResponse = OrErrorMessage<
  t.TypeOf<typeof OrganizationsPageListResponseC>
>

export const UpdateOrganizationBodyC = t.type({
  id: t.string,
  org: OrganizationC,
})
export type UpdateOrganizationBody = t.Type<typeof UpdateOrganizationBodyC>

export const CreateOrganizationBodyC = t.type({
  org: OrganizationC,
})
export type CreateOrganizationBody = t.TypeOf<typeof CreateOrganizationBodyC>

export const CreateOrganizationResponseC = t.type(
  {success: t.boolean, org: withId(OrganizationC)}
)
export type CreateOrganizationResponse = t.TypeOf<typeof CreateOrganizationResponseC>
